module.exports = __webpack_public_path__ + "static/media/loading-circle.45577ea7.gif";